module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_vm._v("APPEAL")]), _vm._v(" "), _c('p', {
    staticClass: "chap_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A")]), _vm._v("s the days of your life turn into years that speed by even faster and your time left it does steal")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("It is only on judgment day, that you finally understand that there is no higher court of appeal.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("You will have been judged by the highest court there ever will be")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And only there will you utterly understand your choices that you made for your entire life decided whether your soul will be imprisoned or be set free.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("It is impossible to decide what to do for every second that goes by")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And is unneeded if you embed the iron rod of God in your soul and like a compass needle keeps you on course to heaven’s gate on high.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("All the endless glories of heaven have been promised by God the Father to be within your grasp")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you but choose to devote and live a truly righteous life that opens the gates of Heaven’s hasp.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("The highest glory of heaven cannot ever be entered alone")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For you must have an eternal mate at your side where love has your hearts entwined and not a single sin left to atone.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("There is no mortal goal or thing that is more important than your salvation")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("And with the complete understanding that you chose to put your soul at risk, to prove worthy of returning to thank and honor God and Christ with love’s pure adoration.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("As the days of your life turn into years that speed by even faster and your time left it does steal")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("It is only on judgment day, that you finally understand that there is no higher court of appeal.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7226ddf9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap010.vue
// module id = 96
// module chunks = 0